import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import React from 'react';

import { buttons } from '@/styles/buttons';

import { DotsIcon } from '@/ui/Icons/DotsIcon';

import { classNames } from '@/utils/classnames';

import { PulsingDot } from '../PulsingDot';

interface AdditionalOptionsTriggerProps {
  isOpen: boolean;
  isMobile: boolean;
  showPulsingDot?: boolean;
}

export const AdditionalOptionsTrigger: React.FC<AdditionalOptionsTriggerProps> = (props) => {
  const { isOpen, isMobile, showPulsingDot } = props;

  return (
    <div className="relative">
      <DropdownMenu.Trigger
        className={buttons({
          size: 'medium',
          color: 'white',
          shape: 'circle',
          iconOnly: true,
          class: 'p-3',
        })}
      >
        {!isMobile && <DotsIcon />}
        {isMobile && (
          <span className="relative size-4">
            <span
              className={classNames(
                'absolute left-0 h-[1.5px] w-4 rounded-full bg-current transition-all duration-500 ease-[cubic-bezier(0.68,-0.55,0.265,1.55)]',
                isOpen ? 'top-1/2 -translate-y-1/2 rotate-45' : 'top-1',
              )}
            />
            <span
              className={classNames(
                'absolute left-0 h-[1.5px] w-4 rounded-full bg-current transition-all duration-500 ease-[cubic-bezier(0.68,-0.55,0.265,1.55)]',
                isOpen ? 'top-1/2 -translate-y-1/2 -rotate-45' : 'top-2.5',
              )}
            />
          </span>
        )}
        <VisuallyHidden>Additional Options</VisuallyHidden>
      </DropdownMenu.Trigger>
      {showPulsingDot && <PulsingDot />}
    </div>
  );
};
